import { RootState } from '@store/store'
import { createSelector } from 'reselect'

export const selectAuth = (state: RootState) => state.auth
export const selectIsLoggedIn = createSelector(
  [selectAuth],
  (auth) => auth.user !== null
)
export const selectTtl = createSelector([selectAuth], (auth) =>
  auth.user ? new Date(auth.user.ttl) : null
)
export const selectAuthLoading = createSelector(
  [selectAuth],
  (auth) => auth.loading
)
export const selectAuthError = createSelector(
  [selectAuth],
  (auth) => auth.error
)
export const selectUser = createSelector([selectAuth], (auth) => auth.user)
